module.exports = __webpack_public_path__ + "static/media/2.248a7826.jpg";